import utilities from '@/helpers/utilities';

export default {
    build() {
        return {
            id: 0,
            acronym: '',
            name: '',
            email: '',
            isActive: true,
            controlAccess: false,
            controlContract: false,
            controlEvaluation: false,
            evaluationStartDate: ''
        };
    },

    toForm(obj) {
        return utilities.toForm(obj, this.build());
    },

    toPayload(obj) {
        return utilities.toPayload(obj);
    },
};


// WEBPACK FOOTER //
// ./src/helpers/entities/Office.js